import clsx from 'clsx'

interface ReverCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
}

const ReverCard: React.FC<ReverCardProps> = ({ children, ...props }) => {
  return (
    <div
      {...props}
      className={clsx(
        'mt-6 w-[83%] max-w-[32rem] bg-white lg:mb-4 lg:mt-10 lg:rounded-lg lg:px-8 lg:py-6 lg:shadow-sm',
        props.className
      )}
    >
      {children}
    </div>
  )
}

export default ReverCard
